<div>
    <div class="loader"></div>
    <input type="hidden" id="ssoUrl"
        value="https://batinternet.speedpay.com/api/brightspeed/sso?cid=BrightspeedSSO" size="70" /><br>
    <input type="hidden" id="secretKey" [(ngModel)] ="secretKey" [ngModelOptions]="{standalone: true}" value="PJbE8oRQ3Hs1sVDG2Wrjdp64U/8STtT2isvtmbGVEUU="
        size="60" /><br>
    <input type="hidden" id="separator" value="|^|" /><br>
    <input id="checkboxTimestamp" [(ngModel)] ="checkboxTimestamp" [ngModelOptions]="{standalone: true}" type="checkbox" checked style="display: none;"><br>
    <input id="checkboxWalletron" [(ngModel)] ="checkboxWalletron" [ngModelOptions]="{standalone: true}" type="checkbox" style="display: none;"><br>
    <br>
    <div id="credentials">
        <input type="hidden" name="sp_credit_account" [(ngModel)]="account" [ngModelOptions]="{standalone: true}" value="657893210124" /><br>
        <input type="hidden" id="speedframe_callback_url" [(ngModel)]="url" [ngModelOptions]="{standalone: true}" name="speedframe_callback_url"/><br>
    </div>
    <br>
    <form method="POST" ngNoForm #testForm name="testForm" id="postForm" >
        <input type="hidden" [(ngModel)] = "postData" [ngModelOptions]="{standalone: true}" id="postData" name="post_data" />
        <input type="hidden" [(ngModel)] = "iv" id="iv" [ngModelOptions]="{standalone: true}" name="IV" />
    </form>

</div>